import { Card } from "@mantine/core";

export const cardComponentSettings = Card.extend({
  defaultProps: {
    radius: "lg",
    withBorder: true,
    shadow: "sm",
  },
});
